import React from 'react'
import './index.css'
import { priceFormatter } from '../../Helpers'
import PropTypes from 'prop-types'
import { Link } from '@walmart-web/livingdesign-components'
import texts from '../../common/texts.json'
import { logEventToDataCollection } from '../../data-tagging'
import { EVENTS, ORIGINS, FLOW_TYPES } from '../../data-tagging/constants'

const BuyboxMoreSellerOptions = ({ quantity, price, setModalIsOpen, flowType, productId }) => {
  const { BUYBOX_SELLER_OPTIONS } = texts

  return (
    <div className={'bso__general'}>
      <div className={'bso__more-options__text'}>
        {BUYBOX_SELLER_OPTIONS.MORE_SELLERS_OPTION} ({quantity})
      </div>
      <div className={'bso__price__text'}>
        {BUYBOX_SELLER_OPTIONS.PRICE} {priceFormatter(price)}
      </div>
      <Link
        className="bso__seller-compare__link"
        href="#"
        onClick={(e) => {
          e.preventDefault()
          logEventToDataCollection({
            origin: ORIGINS.PDP,
            flowType: flowType || FLOW_TYPES.PDP,
            eventName: EVENTS.VIEW_BUYBOX_SELLER_OPTIONS,
            data: { productId },
          })
          setModalIsOpen(true)
        }}
      >
        {BUYBOX_SELLER_OPTIONS.SELLERS_COMPARE}
      </Link>
    </div>
  )
}

BuyboxMoreSellerOptions.propTypes = {
  quantity: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  setModalIsOpen: PropTypes.func,
  flowType: PropTypes.string,
  productId: PropTypes.string,
}

BuyboxMoreSellerOptions.defaultProps = {
  setModalIsOpen: () => {},
  flowType: '',
}
export default React.memo(BuyboxMoreSellerOptions)
